import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, timeout } from 'rxjs/operators';
import { ApiCallService } from './api-call.service';
import { ApiBaseUrlService } from './api-base-url.service';
import { endPoints } from '../api-end-points';
import { Banner } from '../Models/BannerModel';
import { Resource } from '../Models/ResourceModel';
import { NRIModel } from '../Models/NRIModel';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  private apiUrl: string;

  constructor(
    private http: HttpClient,
    private apiCall: ApiCallService,
    private apiBaseUrlService: ApiBaseUrlService
  ) {
    this.apiUrl = this.apiBaseUrlService.getBaseUrl();
  }

  getBanner(): Observable<any> {
    return this.http.get(`${this.apiUrl}/v1/rest/en-us/mix-post/portal/GetBannerData`)
      .pipe(
        timeout(10000), // 10 second timeout
        retry(1), // Retry failed request once
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'An unknown error occurred!';
    
    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    
    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  }

  getResources(): Observable<Resource> {
     //return this.http.get<{ items: Resource[] }>('assets/data/resources.json');
    return this.apiCall.GetJson('assets/data/homeResources.json');
    //return this.apiCall.Get(endPoints.GET_RESOURCES);
  }

  getTutor(): Observable<any> {
    return this.apiCall.Get(endPoints.GET_TUTOR_ORDER_BY_ASC);
  }

  getNRI(): Observable<NRIModel[]> {
     return this.apiCall.GetJson('/assets/data/homeNriList.json');
    //return this.apiCall.Get(endPoints.GET_NRI);
  }

  getNRIPost(dataID: string): Observable<Array<any>> {
    const params = { dataId: dataID };
    return this.apiCall.Get(endPoints.GET_NRIPOST+dataID);
  }

}
